import { Box, Divider, Tooltip, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material/styles";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../common/breadcrumbs";
import DevicesService from "../api/devices";
import CommonDateTimePicker from "../common/commonDateTimePicker";
import {
  GetDateTimeStringToday,
  getUrlVars,
  LatestDataColoring,
} from "../utils/systemInfo";
import { UserPermissionConstants } from "../utils/permissions";
import utils from "../utils/utils";
import Loading from "../common/loading";
import DevicesMenu from "../common/devicesMenu";
import { setDeviceData } from "../store/deviceSlice";
import StyledTypography from "../common/StyledTypography";
import TableGreenTypography from "../common/TableGreenTypography";

const breadcrumbs = [
  { id: 0, name: "Home", href: "./" },
  { id: 1, name: "Machines", href: "machines" },
  { id: 2, name: "BM10", href: "" },
  { id: 3, name: "History", href: "" },
];

const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  width: "160px",
  // height: "32px",
  color: theme.palette.custom.buttonTextColor,
  backgroundColor: theme.palette.custom.buttonColor,
  borderColor: theme.palette.custom.borderColor,
  borderWidth: "1px",
  borderStyle: "solid",
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
}));
const NumberTypography = styled((props) => <Typography {...props} />)(
  ({ theme }) => ({
    color: theme.palette.custom.borderColor,
    m: 0,
  })
);
function DeviceHistory() {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const device = useSelector(({ device }) => device);
  const permissions = useSelector(({ permissions }) => permissions);
  const organziation = useSelector(({ organziation }) => organziation);
  const [loadingValue, setLoadingValue] = useState(true);
  const [grafanaLink, setGrafanaLink] = useState(undefined);
  const [devicesList, setDevicesList] = useState(undefined);
  const timezoneMins = useSelector(({ timezone }) => timezone);
  const DeviceTitleDataName = String(getUrlVars()["DeviceTitleDataName"]);

  useEffect(() => {
    handleGetDeviceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleBreadCrumbsArray = (breadcrumbs, device) => {
    if (DeviceTitleDataName === "Device") {
      breadcrumbs[1] = {
        id: 1,
        name: "Devices",
        href: "devices",
      };
    }
    if (breadcrumbs.length >= 3) {
      switch (DeviceTitleDataName) {
        case "Device":
          breadcrumbs[2] = {
            id: 2,
            name: device.DeviceName,
            href: `/device?device=${device.DeviceID}&DeviceTitleDataName=${device.DeviceTitleDataName}&Dashboard=${device.GrafanaDashboardUID}&MachineName=${device.DeviceName}&device_uid=${device.DeviceID}`,
            noTranslation: true,
          };
          break;
        case "Machine":
        default:
          breadcrumbs[2] = {
            id: 2,
            name: device.DeviceName,
            href: `/device?device=${device.DeviceID}&DeviceTitleDataName=${device.DeviceTitleDataName}`,
            noTranslation: true,
          };
          break;
      }
      breadcrumbs[3] = {
        id: 3,
        name: "History",
        href: window.location.href,
      };
      return breadcrumbs;
    }
    breadcrumbs.push({
      id: 1,
      name: device.DeviceName,
      href: `/device?device=${device.DeviceID}`,
      noTranslation: true,
    });
    return breadcrumbs;
  };
  function handleAssignEditDashboard() {
    if (grafanaLink) window.open(grafanaLink, "_blank").focus();
  }
  const handleUpdateGrafanaLink = (newUrl) => {
    const newGrafanaLink = newUrl
      .replaceAll(
        window.env.REACT_APP_GRAFANA_URL,
        window.env.REACT_APP_EDITGRAFANA_URL
      )
      .replaceAll("&kiosk=true", "");

    setGrafanaLink(newGrafanaLink);
  };
  function handleGetDeviceData() {
    const DeviceId = String(getUrlVars()["device_uid"]);
    setDevicesList(undefined);
    dispatch(setDeviceData(null));
    const apiKey = organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
    if (apiKey) {
      //const apiKey = organziation?.api_key_list?.[0]?.key;
      let DevicesClass;
      switch (DeviceTitleDataName.toLowerCase()) {
        case "machine":
        default:
          DevicesClass = {
            deviceType: [
              "nerohub",
              "nanohub",
              "cyberhub",
              "stratahub",
              "nerotrax",
              "train",
              "autonomous hub",
            ],
            source: "",
          };
          DevicesService.getDevices({
            DeviceID: DeviceId ? Number(DeviceId) : "",
            DeviceType: DevicesClass.deviceType,
            Source: DevicesClass.source,
            apiKey,
            HistoryFromDST: "",
            HistoryToDST: GetDateTimeStringToday(),
          })
            .then((json) => {
              if (
                json &&
                json.device_profile &&
                json.device_profile.length > 0
              ) {
                // setOpsumInputData({
                //     json, machineTypeFilter: "",
                // })
                const deviceObject = json.device_profile.find(
                  (x) => x.device_uid.toString() === DeviceId
                );
                dispatch(
                  setDeviceData({
                    json: deviceObject,
                    machineTypeFilter: "",
                    machineType: DeviceTitleDataName,
                  })
                );
                setDevicesList(json.device_profile);
              } else {
                navigate("/");
              }
              setLoadingValue(false);
            })
            .catch((errorr) => {
              if (process.env.NODE_ENV === "development")
                console.log("getUserTypePermissionserrorr", errorr);
            });
          break;

        case "device":
          DevicesClass = { deviceType: [], source: "iot" };
          DevicesService.getDevices({
            DeviceID: DeviceId ? Number(DeviceId) : "",
            DeviceType: DevicesClass.deviceType,
            Source: DevicesClass.source,
            Live: false,
            History: false,
            apiKey,
            HistoryFromDST: "",
            HistoryToDST: GetDateTimeStringToday(),
          })
            .then((json) => {
              if (
                json &&
                json.device_profile &&
                json.device_profile.length > 0
              ) {
                // setOpsumInputData({
                //     json, machineTypeFilter: "",
                // })
                const deviceObject = json.device_profile.find(
                  (x) => x.device_uid.toString() === DeviceId
                );
                dispatch(
                  setDeviceData({
                    json: deviceObject,
                    machineTypeFilter: "",
                    machineType: DeviceTitleDataName,
                  })
                );
                setDevicesList(json.device_profile);
              } else {
                navigate("/");
              }
              setLoadingValue(false);
            })
            .catch((errorr) => {
              if (process.env.NODE_ENV === "development")
                console.log("getUserTypePermissionserrorr", errorr);
            });
          break;
      }
    }
  }
  return (
    <Box
      sx={{
        p: "8px",
        minHeight: `100%`,
        height: "100%",
      }}
    >
      <Box sx={{ width: "100%"}}>
        {!loadingValue && device ? (
          <Breadcrumbs
            breadcrumbs={handleBreadCrumbsArray(breadcrumbs, device)}
          />
        ) : (
          <Box sx={{ height: "10vh", pt: "3%" }}>
            <Loading />
          </Box>
        )}
        {!loadingValue && device ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              flexFlow: { xs: "column", sm: "row" },
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Box
              sx={{
                textAlign: "center",
                width: {
                  xs: "100%",
                  sm: DeviceTitleDataName !== "Device" ? "20%" : "30%",
                },
                marginRight: { xs: 0, sm: "5%" },
                display: "flex",
                flexFlow: "row",
                alignItems: "center",
              }}
            >
              <div
                style={{ width: "50px" }}
                dangerouslySetInnerHTML={{
                  __html: device.DeviceTypeIcon.replace(
                    "theme.palette.custom.text",
                    theme.palette.custom.text
                  ),
                }}
              />
              {devicesList && devicesList.length > 0 ? (
                <DevicesMenu
                  handleChangeDevice={handleGetDeviceData}
                  pageType="history"
                  devices={devicesList}
                  isSmall={true}
                />
              ) : (
                <NumberTypography variant="h6">
                  {device.DeviceName}
                </NumberTypography>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexFlow: "row",
                width: {
                  xs: "100%",
                  sm: DeviceTitleDataName !== "Device" ? "25%" : "30%",
                },
                marginRight: { xs: 0, sm: "5%" },
                p: { xs: 0, sm: "12px" },
                textAlign: "center",
              }}
            >
              <StyledTypography variant="h6">
                {t("LastSeenWithDots")} &nbsp;
              </StyledTypography>
              <Typography
                sx={{
                  color: LatestDataColoring(device.DeviceLastSeen, true),
                  display: "flex",
                  flexFlow: "row",
                  alignItems: "center",
                }}
                variant="h6"
              >
                {moment
                  .utc(device.DeviceLastSeen)
                  .add(timezoneMins, "minutes")
                  .format("YYYY-MM-DD HH:mm")}
              </Typography>
            </Box>
            {DeviceTitleDataName !== "Device" && (
              <Box
                sx={{
                  display: "flex",
                  flexFlow: "row",
                  width: { xs: "100%", sm: "30%" },
                  p: { xs: 0, sm: "12px" },
                  textAlign: "center",
                }}
              >
                <StyledTypography variant="h6">
                  {t("LastLocation")} &nbsp;
                </StyledTypography>

                {device.NamedLocationOriginal === "Unknown" ? (
                  <TableGreenTypography
                    sx={{
                      color: "red",
                    }}
                    variant="h6"
                  >
                    {device.NamedLocationOriginal}
                  </TableGreenTypography>
                ) : (
                  <StyledTypography variant="h6">
                    {device.NamedLocationOriginal}
                  </StyledTypography>
                )}
              </Box>
            )}
            {permissions &&
              utils.hasPermission(
                UserPermissionConstants.OPEN_DASHBOARD_LINK_IN_GRAFANA,
                permissions
              ) && (
                <>
                  <Tooltip title={t("OpenInGrafana")}>
                    <StyledButton
                      variant="contained"
                      onClick={handleAssignEditDashboard}
                    >
                      {t("EditDashboard")}
                    </StyledButton>
                  </Tooltip>
                </>
              )}
          </Box>
        ) : null}
      </Box>

      <Divider
        sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
      <Box
        sx={{
          height: { xs: "100%", sm: `calc(100% - 94px)` },
        }}
      >
        <CommonDateTimePicker
          handleUpdateGrafanaLink={handleUpdateGrafanaLink}
        />
      </Box>
    </Box>
  );
}

export default DeviceHistory;
